import { useState, useEffect, useRef } from "react";
import { PublicFooter, PublicTitle, PublicNavbar } from "../components/pagestyle";

export default function Contact() {
    useEffect(() => {
        // Ensure the HubSpot embed script is loaded dynamically
        const script = document.createElement("script");
        script.src = "https://js.hsforms.net/forms/embed/48174566.js"; // Provided script URL
        script.defer = true; // Ensures the script loads asynchronously
        document.body.appendChild(script);
    }, []);

    window.document.title = "fAlpha.ai | Contact Us";

    return (
        <>  
            <PublicNavbar />
            <PublicTitle title="Request a Demo" />
            <br></br><br></br>
            {/* Embed form */}
            <div
                className="hs-form-frame"
                data-region="na1"
                data-form-id="8b0a7cd5-3811-4035-aef8-db59dc94c0fa"
                data-portal-id="48174566"
            ></div>
            <PublicFooter />
        </>
    );
}
